/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import InputMask from 'react-input-mask';
import Swal from 'sweetalert2';

function CreateAccount() {

  const [formData, setFormData] = useState({
    nome_empresa: '', // Replace with your actual field names
    nome_fantasia: '', // Replace with your actual field names
    // ... other fields
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let isValid = true;
    let errors = {};

    if (!formData.fieldName) {
      isValid = false;
      errors.fieldName = 'Este é um campo obrigatório';
    }

    // Add more validation checks for other fields as necessary

    setErrors(errors);
    return isValid;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const isValid = validateForm();

    if (isValid) {
      // Proceed with form submission, e.g., API call
      console.log('Form data submitted:', formData);
    }
  };


  return (
    <div className="flex justify-center items-center self-stretch px-16 py-12 max-md:px-5">
      <div className="flex flex-col items-center pb-3 mt-5 w-full max-w-[1120px] max-md:mt-5 max-md:max-w-full">
        <div className="flex gap-4 self-stretch text-sm leading-5 text-neutral-900 max-md:flex-wrap max-md:max-w-full">
          <div>Acesso</div>
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/7e09f87e37c5b0576ce3eedbddaa65ac5543cc3df81e0997bccd4370515e32d6?"
            className="my-auto w-4 aspect-square"
          />
          <div className="flex-auto font-bold max-md:max-w-full">
            Criar conta
          </div>
        </div>
        <div className="mt-10 text-base font-bold leading-6 text-center text-neutral-600 max-md:mt-10 max-md:max-w-full">
          DADOS DA EMPRESA
        </div>
        <div className="flex gap-5 justify-between mt-16 max-w-full w-[632px] max-md:flex-wrap max-md:mt-10">
          <div className="flex flex-col flex-1">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900">
              nome da empresa *
            </div>
            <input className="justify-center px-4 py-3 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500" name="nome_empresa" placeholder="Dados da empresa" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}

          </div>
          <div className="flex flex-col flex-1">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900">
              nome fantasia *
            </div>
            <input className="justify-center px-4 py-3 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500" name="nome_fantasia" placeholder="Nome fantasia" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
        </div>
        <div className="flex gap-2 self-start mt-8 ml-60 text-sm font-bold leading-5 uppercase whitespace-nowrap text-neutral-900 max-md:ml-2.5">
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/e07d6b6402ce60b0e2d39a47fce259ea35a328222a362e475aeee45b76552505?"
            className="w-6 aspect-square"
          />
          <div className="grow my-auto">ADICIONAR LOGOTIPO DA EMPRESA</div>
        </div>
        <div className="flex gap-4 mt-8 max-w-full w-[632px] max-md:flex-wrap">
          <div className="flex flex-col flex-1">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900">
              cnpj *
            </div>
            <InputMask className="justify-center px-4 py-3 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500" name="cnpj" placeholder="00.000.000/0000-00" mask="99.999.999/9999-99" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
          <div className="flex flex-col flex-1">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900">
              E-mail *
            </div>
            <input className="justify-center py-3 pr-2 pl-4 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500" name="email" placeholder="Email" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
          <div className="flex flex-col flex-1 pr-11">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900">
              telefone *
            </div>
            <InputMask className="justify-center px-4 py-3 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500" mask="(99) 99999-9999" name="telefone" placeholder="(00) 00000-0000" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
        </div>
        <div className="flex gap-4 mt-6 max-w-full w-[632px] max-md:flex-wrap">
          <div className="flex flex-col flex-1">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900">
              Endereço *
            </div>
            <input className="justify-center px-4 py-3 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500" name="endereco" placeholder="Endereço" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
          <div className="flex flex-col whitespace-nowrap basis-0">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900">
              Complemento
            </div>
            <input className="justify-center px-4 py-3 mt-3 text-xs leading-5 rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500" name="complemento" placeholder="Complemento" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
        </div>
        <div className="flex gap-4 mt-6 max-w-full w-[632px] max-md:flex-wrap">
          <div className="flex flex-col flex-1 max-md:max-w-full">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900 max-md:max-w-full">
              bairro *
            </div>
            <input className="justify-center px-4 py-3 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500 max-md:max-w-full" name="bairro" placeholder="Bairro" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
          <div className="flex flex-col basis-0">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900">
              cep *
            </div>
            <InputMask className="justify-center px-4 py-3 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500" name="cep" mask="99999-999" placeholder="00000-000" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
        </div>
        <div className="flex gap-4 mt-6 max-w-full w-[632px] max-md:flex-wrap">
          <div className="flex flex-col whitespace-nowrap basis-0">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900">
              estado *
            </div>
            <input className="justify-center px-4 py-3 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500 max-md:max-w-full" name="estado" placeholder="UF" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
          <div className="flex flex-col flex-1 max-md:max-w-full">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900 max-md:max-w-full">
              cidade *
            </div>
            <input className="justify-center px-4 py-3 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500 max-md:max-w-full" name="cidade" placeholder="Cidade" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
        </div>
        <div className="mt-16 text-base font-bold leading-6 text-center text-neutral-600 max-md:mt-10 max-md:max-w-full">
          DADOS DO RESPONSÁVEL
        </div>
        <div className="flex gap-5 justify-between mt-16 max-w-full w-[632px] max-md:flex-wrap max-md:mt-10">
          <div className="flex flex-col flex-1">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900">
              NOME *
            </div>
            <input className="justify-center items-start py-3 pr-16 pl-4 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500 max-md:pr-5" name="nome" placeholder="Nome" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
          <div className="flex flex-col flex-1">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900">
              SOBRENOME *
            </div>
            <input className="justify-center px-4 py-3 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500" name="sobrenome" placeholder="Sobrenome" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
        </div>
        <div className="flex gap-5 justify-between mt-6 max-w-full w-[632px] max-md:flex-wrap">
          <div className="flex flex-col basis-0">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900">
              TELEFONE *
            </div>
            <InputMask className="justify-center px-4 py-3 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500" mask="(99) 99999-9999" name="telefone_contato" placeholder="(00) 00000-0000" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
          <div className="flex flex-col flex-1 max-md:max-w-full">
            <div className="text-sm font-bold leading-5 uppercase text-neutral-900 max-md:max-w-full">
              E-MAIL *
            </div>
            <input className="justify-center items-start py-3 pr-16 pl-4 mt-3 text-xs leading-5 whitespace-nowrap rounded border-solid border-[1.5px] border-[color:var(--PdM-Gray-100,#E3E5E8)] text-zinc-500 max-md:pr-5 max-md:max-w-full" name="email_contato" placeholder="Email" />
            {errors.fieldName && <div className="text-red-600 text-xs italic mt-2">{errors.fieldName}</div>}
          </div>
        </div>
        <div className="flex gap-5 justify-between self-end pl-4 mt-14 mr-60 text-base leading-6 text-center whitespace-nowrap max-md:mt-10 max-md:mr-2.5">
          <Link to="../login" className="my-auto text-zinc-600">Cancelar</Link>
          <div className="grow justify-center px-4 py-2 text-white bg-lime-700 rounded-sm border border-solid shadow-sm border-[color:var(--Polar-Green-7,#389E0D)] cursor-pointer" onClick={handleSubmit}>
            Confirmar Solicitação
          </div>
        </div>
      </div>
    </div>
  );
}
export default CreateAccount; 